import { Link } from "react-router-dom";

// Ordre : les ancres les plus longues/spécifiques d'abord.
export const GLOBAL_LINKS = [
  { anchor: "recherche de fuite", to: "/fuite-toiture-94" },
  { anchor: "réfection de toiture", to: "/refection-toiture-94" },
  { anchor: "rénovation de toiture", to: "/renovation-toiture-94" },
  { anchor: "réparation de toiture", to: "/reparation-toiture-94" },
  { anchor: "réparations nécessaires", to: "/reparation-toiture-94" },
  { anchor: "réfection", to: "/refection-toiture-94" },
  { anchor: "rénovation", to: "/renovation-toiture-94" },
  { anchor: "démoussage", to: "/demoussage-toiture-94" },
  { anchor: "gouttières", to: "/gouttiere-94" },
  { anchor: "gouttière", to: "/gouttiere-94" },
  { anchor: "zinguerie", to: "/zinguerie-94" },
  { anchor: "étanchéité", to: "/etancheite-toiture-94" },
  { anchor: "charpente", to: "/charpente-94" },
  { anchor: "Champigny-sur-Marne", to: "/couvreur-champigny-sur-marne" },
  { anchor: "dans le Val-de-Marne", to: "/couvreur-94" },
  { anchor: "Val-de-Marne", to: "/couvreur-94" },
];

const linkCls =
  "text-signal underline decoration-signal/40 underline-offset-4 hover:decoration-signal transition-colors duration-300";

// Lien contextuel : première occurrence de chaque ancre, une seule fois par page,
// jamais vers la page courante, au maximum un lien par paragraphe.
export const linkify = (text, used, currentPath) => {
  const lower = text.toLowerCase();
  for (const { anchor, to } of GLOBAL_LINKS) {
    if (to === currentPath || used.has(anchor)) continue;
    const idx = lower.indexOf(anchor.toLowerCase());
    if (idx === -1) continue;
    used.add(anchor);
    return [
      text.slice(0, idx),
      <Link key={`${to}-${idx}`} to={to} className={linkCls}>
        {text.slice(idx, idx + anchor.length)}
      </Link>,
      text.slice(idx + anchor.length),
    ];
  }
  return text;
};
